import getConfig from 'next/config';

export const PHASE_1 = 1;
export const PHASE_2 = 2;

export function getPhase() {
  const { publicRuntimeConfig } = getConfig();
  return parseFloat(publicRuntimeConfig.PHASE, 10);
}
